import * as Locales from '@/infra/locales'
import * as Settings from '@/infra/settings'

const SCRIPT_ID = 'ui-google-maps-script'
const localeToGoogleLang = () => {
  const locale = Settings.getLocale()

  switch (locale) {
    case Locales.types.ES:
      return 'es'
    case Locales.types.FR:
      return 'fr'
    case Locales.types.IT:
      return 'it'
    case Locales.types.EN:
      return 'en'
    case Locales.types.DE:
      return 'de'
    default:
      throw new Error(`googleMap.localeToGoogleLang error: locale: ${locale} not implemented yet`)
  }
}

export const injectScript = () => new Promise((resolve, reject) => {
  if (document.querySelector(`#${SCRIPT_ID}`) == null) {
    const script = document.createElement('script')

    script.id = SCRIPT_ID
    script.type = 'text/javascript'
    script.src = `https://maps.googleapis.com/maps/api/js?key=${Settings.getGoogleMapKey()}&libraries=places,geometry&language=${localeToGoogleLang()}`
    script.onload = resolve
    script.onerror = reject

    document.head.appendChild(script)
  } else {
    resolve()
  }
})

export const removeScript = () => {
  if (document.querySelector(`#${SCRIPT_ID}`) != null) {
    const script = document.querySelector(`#${SCRIPT_ID}`)
    script.remove()
  }
}
